"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INDICATIF_STREET = exports.STREET_TYPES = exports.isFromFranceOrDomTom = exports.isFrance = void 0;
const isFrance = (country) => ['fr', 'france'].includes(country.toLowerCase());
exports.isFrance = isFrance;
// Values are from Infogreffe
const isFromFranceOrDomTom = (country) => [
    'FRANCE',
    'GUADELOUPE',
    'MARTINIQUE',
    'GUYANE',
    'LA REUNION',
    'MAYOTTE',
    'SAINT-PIERRE ET MIQUELON',
    'SAINT-BARTHELEMY',
    'SAINT-MARTIN',
    'ILES WALLIS ET FUTUNA',
    'POLYNESIE FRANCAISE',
    'NOUVELLE CALEDONIE',
    'TERRES AUSTRALES FRANCAISES',
].includes(country.toUpperCase());
exports.isFromFranceOrDomTom = isFromFranceOrDomTom;
exports.STREET_TYPES = {
    Allée: ['Allée', 'ALL'],
    Appartement: ['Appartement'],
    Arcade: ['Arcade'],
    Arrondissement: ['Arrondissement'],
    Atelier: ['Atelier'],
    Autoroute: ['Autoroute'],
    Avenue: ['Avenue', 'AVE', 'AV'],
    'Bas (se, ses)': ['Bas'],
    Berge: ['Berge'],
    Boulevard: ['Boulevard', 'BD'],
    'Boîte postale': ['Boîte postale', 'BP'],
    Bâtiment: ['Bâtiment'],
    Chemin: ['Chemin', 'CHE'],
    Cité: ['Cité'],
    Corniche: ['Corniche'],
    Cours: ['Cours', 'CRS'],
    Domaine: ['Domaine'],
    Escalier: ['Escalier'],
    Esplanade: ['Esplanade'],
    Etage: ['Etage'],
    Faubourg: ['Faubourg', 'FG'],
    Immeuble: ['Immeuble', 'IMM'],
    Impasse: ['Impasse', 'IMP'],
    'Lieu-dit': ['Lieu-dit', 'LD'],
    Lotissement: ['Lotissement', 'LOT'],
    Parc: ['Parc'],
    Passage: ['Passage', 'PAS'],
    Place: ['Place', 'PL'],
    Promenade: ['Promenade', 'PRO'],
    Quai: ['Quai'],
    Quartier: ['Quartier'],
    'Rond point': ['Rond point', 'RPT'],
    Route: ['Route', 'RTE'],
    Rue: ['Rue'],
    Ruelle: ['Ruelle', 'RLE'],
    Résidence: ['Résidence', 'RES'],
    Square: ['Square', 'SQ'],
    Tour: ['Tour'],
    Villa: ['Villa'],
    Zone: ['Zone'],
};
exports.INDICATIF_STREET = {
    bis: 'Bis',
    quater: 'Quater',
    quinquies: 'Quinquies',
    ter: 'Ter',
};
